import { render, staticRenderFns } from "./FcucBuyQuestTicket.vue?vue&type=template&id=0197ef00&scoped=true&"
import script from "./FcucBuyQuestTicket.vue?vue&type=script&lang=js&"
export * from "./FcucBuyQuestTicket.vue?vue&type=script&lang=js&"
import style0 from "./FcucBuyQuestTicket.vue?vue&type=style&index=0&id=0197ef00&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0197ef00",
  null
  
)

export default component.exports